import { NgModule } from '@angular/core';
import { AuthenticationService } from '@app/core/services/authentication/authentication.service';

@NgModule({
	providers: [AuthenticationService]
})
export class NewCoreModule {}
export { AuthenticationService } from './services/authentication/authentication.service';
